"use strict";

module.exports = /* @ngInject */ function(
  openFinApi,
  eikonLightInstaller,
  eikonAttributeRepository,
  eikonErrorCodes,
  $q,
  $log
) {
  var that = this;

  var DEFAULT_EIKON_INSTALLATION_ERROR_MESSAGE =
    "An unexpected error occurred while installing Eikon";

  var DEFAULT_EIKON_LAUNCH_ERROR_MESSAGE =
    "An unexpected error occurred while launching Eikon";

  that.launch = function(sxsPort) {
    return eikonLightInstaller.maybeInstallOrUpgrade(sxsPort).then(
      function() {
        return openFinApi.getFin().then(function(fin) {
          return getEnvironment("LOCALAPPDATA", fin).then(function(
            localAppDataDirectory
          ) {
            return eikonAttributeRepository
              .getEikonLightAttributes(sxsPort)
              .then(function(eikonLightAttributes) {
                return launchFromLocalAppData(
                  localAppDataDirectory,
                  fin,
                  eikonLightAttributes
                ).then(undefined, function(error) {
                  $log.error("Error in launching... ", error);
                  return $q.reject(
                    error || new Error(DEFAULT_EIKON_LAUNCH_ERROR_MESSAGE)
                  );
                });
              });
          });
        });
      },
      function(error) {
        $log.error("Error in Eikon installation.. ", error);
        return $q.reject(
          error || new Error(DEFAULT_EIKON_INSTALLATION_ERROR_MESSAGE)
        );
      }
    );
  };

  function launchFromLocalAppData(
    localAppDataDirectory,
    fin,
    eikonLightAttributes
  ) {
    return tryLaunch(localAppDataDirectory, fin, eikonLightAttributes).catch(
      function() {
        return eikonLightInstaller.forceReInstall().then(function() {
          return tryLaunch(localAppDataDirectory, fin, eikonLightAttributes);
        });
      }
    );
  }

  function getEnvironment(environmentVar, fin) {
    return $q(function(resolve, reject) {
      fin.desktop.System.getEnvironmentVariable(
        environmentVar,
        resolve,
        reject
      );
    });
  }

  function tryLaunch(localAppData, fin, eikonLightAttributes) {
    const runtimeArgs = eikonLightAttributes.runtimeArguments;
    const executablePath = eikonLightAttributes.executablePath || "\\Eikon\\Eikon.exe";
    const path = localAppData + executablePath;
    $log.info("Attempting to launch: " + path);
    return $q(function(resolve, reject) {
      fin.desktop.System.launchExternalProcess(
        {
          path: path,
          arguments: runtimeArgs,
          listener: function(launchResult) {
            if (launchResult.exitCode === 0) {
              $log.info("Successfully launched Eikon");
              resolve();
            } else {
              $log.error("Error launching Eikon: ", launchResult.exitCode);
              reject(
                new Error(
                  eikonErrorCodes[launchResult.exitCode] ||
                    "Failed to launch Eikon with an unexpected exit code " +
                      launchResult.exitCode
                )
              );
            }
          }
        },
        function() {
          $log.info("Resolved Eikon.exe");
          resolve();
        },
        function(reason, error) {
          $log.error("Could not resolve Eikon.exe ", error);
          reject(new Error(reason));
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./app/infrastructure/eikonLightLauncher.js